import React, { useMemo } from "react";
import { FaMicrochip, FaBell } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Home = ({ alerts, devices }) => {
  const navigate = useNavigate();

  // Calculate alert counts by type
  const { criticalCount, warningCount, infoCount } = useMemo(() => {
    let critical = 0,
      warning = 0,
      info = 0;

    alerts.forEach((alert) => {
      if (alert.type === "Critical") critical++;
      else if (alert.type === "Warning") warning++;
      else if (alert.type === "Info") info++;
    });

    return { criticalCount: critical, warningCount: warning, infoCount: info };
  }, [alerts]);

  const totalDevices = devices.length;

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Dashboard Overview</h1>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        {/* Total Devices */}
        <div
          onClick={() => navigate("/devices")}
          className="bg-gray-800 p-6 rounded-xl shadow-md flex items-center gap-4 cursor-pointer hover:bg-gray-700 transition"
        >
          <div className="p-4 bg-green-600 rounded-full">
            <FaMicrochip className="text-white text-2xl" />
          </div>
          <div>
            <p className="text-gray-400 text-sm">Total Devices</p>
            <p className="text-3xl font-bold text-white">{totalDevices}</p>
          </div>
        </div>

        {/* Total Alerts */}
        <div
          onClick={() => navigate("/alerts")}
          className="bg-gray-800 p-6 rounded-xl shadow-md flex items-center gap-4 cursor-pointer hover:bg-gray-700 transition"
        >
          <div className="p-4 bg-blue-600 rounded-full">
            <FaBell className="text-white text-2xl" />
          </div>
          <div>
            <p className="text-gray-400 text-sm">Total Alerts</p>
            <p className="text-3xl font-bold text-white">{alerts.length}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
